
export const sidebar = {
  transitionDelay: 200
}

// Breakpoints de resoluçoes de tela de acordo com o Bootstrap:
// https://getbootstrap.com/docs/4.0/layout/overview/
export const mediaBreakpoint = {
  xs: 576, // Dispositivos muito pequenos (telefones na vertical, menores que 576px)
  sm: 768, // Dispositivos pequenos (telefones na horizontal, menores que 768px)
  md: 992, // Dispositivos médios (tablets, menores que 992px)
  lg: 1200 // Dispositivos grandes (desktops, menores que 1200px)
  // Dispositivos muito grandes (desktops grandes, tvs)
  // Não é necessário, pois não há limite de resolução
}
